module.exports = __webpack_public_path__ + "img/HomeIcon.55d37b22.svg";